import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/LegalPage";

export const Route = createFileRoute("/aviso-legal")({
  head: () => ({ meta: [{ title: "Aviso legal · SUSIEDAD" }] }),
  component: LegalNotice,
});
function LegalNotice() {
  return (
    <LegalPage eyebrow="Legal · Titularidad" title="AVISO LEGAL">
      <section>
        <h2>Información del titular</h2>
        <p>
          Web profesional de SUSIEDAD, DJ y productor con base en Málaga y servicio en toda España.
        </p>
      </section>
      <section>
        <h2>Contacto</h2>
        <p>Email: lasusiedad@gmail.com · Teléfono: 633 199 708 · Instagram: @la_susiedad.</p>
      </section>
      <section>
        <h2>Contenido y propiedad intelectual</h2>
        <p>
          La marca, logotipos, fotografías, textos y materiales musicales pertenecen a sus
          respectivos titulares y no pueden reutilizarse sin autorización.
        </p>
      </section>
    </LegalPage>
  );
}
